import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=8550bb3c"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"
import style0 from "./VersionList.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports